module.exports = __webpack_public_path__ + "img/6806849a877fbb925ea7afe9267903cf.png";